export default {
	// #region Tab Titles
	TAB_HOME: 'Home',
	TAB_CALENDAR: 'Calendario Permessi',
	TAB_AVAILABILITY: 'Calendario Disponibilità',
	// #endregion

	// #region Home Dashboard
	VISIBLE_COMMUNICATIONS: 'Comunicazioni Visibili',

	UNASSIGNED_REQUESTS: 'Segnalazioni non assegnate',
	WAITING_REQUESTS: 'Segnalazioni in attesa',
	OPEN_REQUESTS: 'Segnalazioni aperte',
	CLOSED_REQUESTS: 'Segnalazioni chiuse',

	UNASSIGNED_LEAVE: 'Permessi non assegnati',
	WAITING_LEAVE: 'Permessi in attesa',
	OPEN_LEAVE: 'Permessi aperti',
	CLOSED_LEAVE: 'Permessi chiusi',

	FAST_ACTIONS_WIDGET_TITLE: 'Azioni rapide',
	LINKS_WIDGET_TITLE: 'Collegamenti',

	VIEW_ITEM_BUTTON_NEW_COMMUNICATION: 'Nuova Comunicazione',
	VIEW_ITEM_BUTTON_NEW_REQUEST: 'Nuova Segnalazione',
	VIEW_ITEM_BUTTON_NEW_LEAVE: 'Nuovo Permesso',
	VIEW_ITEM_BUTTON_NEW_DOCUMENT_FOLDER: 'Nuova Cartella documenti',
	// #endregion

	// #region Card Stats
	DASHBOARD_CARD_TITLE_OPEN_LEAVE_REQUESTS: 'Permessi richiesti',
	DASHBOARD_CARD_TITLE_ACCEPTED_LEAVE: 'Permessi accettati',
	DASHBOARD_CARD_TITLE_OPEN_REQUESTS: 'Segnalazioni aperte',
	DASHBOARD_CARD_TITLE_TAKE_CHARGE_REQUESTS: 'Segnalazioni prese in carico',
	// #endregion

	// #region Calendar Section
	DASHBOARD_BTN_PREV: 'Anno Precedente',
	DASHBOARD_BTN_NEXT: 'Anno Successivo',
	DASHBOARD_CALENDAR_VIEW: 'Calendario Permessi',
	DASHBOARD_CALENDAR_REQUESTED_VIEW_SUBHEADER: 'Permessi richiesti',
	DASHBOARD_CALENDAR_CONFIRMED_VIEW_SUBHEADER: 'Permessi accettati'
	// #endregion
};
